export default __webpack_public_path__ + "static/SectionTwo_01_01-936873e253ddd24544295e41f0361096.webp";